import React from 'react';
import { View, FlatList, Text } from 'react-native';
import { connect } from 'react-redux';

import JourneyPerformanceComponent from "./JourneyPerformanceComponent";
import NavBar from "../../components/NavBar";
import Colors from "../../constants/Colors";

class PerformanceJourneys extends React.Component {

    render() {

        const dataToRender = [...this.props.userInProgressJourneys, ...this.props.userCompletedJourneys];

        return (
            <NavBar title={"Desempenho"}>

                <View style={{ width: 600 }}>
                    {
                        dataToRender.length === 0 &&
                        <Text style={{ color: Colors.fontColorOnBackground, fontSize: 18, textAlign: 'center' }}>
                            Você ainda não tem nenhum dado para ser mostrado!
                        </Text>
                    }

                    <FlatList
                        data={dataToRender}
                        renderItem={({item}) => { return <JourneyPerformanceComponent {...item} /> }}
                        keyExtractor={item => item.SK.toString()}
                    />
                </View>

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        userInProgressJourneys: state.journey.userInProgressJourneys,
        userCompletedJourneys: state.journey.userCompletedJourneys,
    }
}

export default connect(mapStateToProps)(PerformanceJourneys);
